export const rosterCopy = {
  IT: {
    weight: 'Peso', load: 'Carico · 7 giorni', training: 'RPE allenamento', match: 'RPE partita',
    wellness: 'Wellness oggi', missing: 'Non disponibile', noWellness: 'Non compilato',
    latestMatch: 'Ultima partita', noMatch: 'Nessuna partita disponibile', minutes: 'Minuti giocati',
    missingMinutes: 'Dati mancanti', profile: 'Apri profilo atleta', availability: 'Disponibilità',
    details: 'Dettagli atleta', close: 'Chiudi dettagli', noTeam: 'Squadra non disponibile',
    comparison: 'Variazione', weightPeriod: 'Rispetto alla misura precedente',
    loadPeriod: 'Ultimi 7 giorni rispetto ai 7 precedenti', trainingPeriod: 'Media ultimi 7 giorni rispetto ai 7 precedenti',
    matchPeriod: 'Ultime 3 presenze con RPE rispetto alle 3 precedenti', points: 'pt',
    green: 'Verde', amber: 'Ambra', red: 'Rosso', friendly: 'Amichevole', competitive: 'Partita',
    error: 'Impossibile caricare gli atleti', retry: 'Riprova', measurement: 'Misurazione', phase: 'Fase',
    dateMissing: 'Data non disponibile', position: 'Ruolo', allPositions: 'Tutti i ruoli',
  },
  EN: {
    weight: 'Weight', load: 'Load · last 7 days', training: 'Training RPE', match: 'Match RPE',
    wellness: 'Wellness today', missing: 'Unavailable', noWellness: 'Not submitted',
    latestMatch: 'Latest match', noMatch: 'No match available', minutes: 'Minutes played',
    missingMinutes: 'Missing data', profile: 'Open Athlete Profile', availability: 'Availability',
    details: 'Athlete details', close: 'Close details', noTeam: 'Team unavailable',
    comparison: 'Change', weightPeriod: 'Compared with the previous measurement',
    loadPeriod: 'Last 7 days compared with the preceding 7 days', trainingPeriod: 'Last 7-day mean compared with preceding 7 days',
    matchPeriod: 'Latest 3 appearances with RPE compared with the preceding 3', points: 'pts',
    green: 'Green', amber: 'Amber', red: 'Red', friendly: 'Friendly match', competitive: 'Match',
    error: 'Unable to load athletes', retry: 'Retry', measurement: 'Measurement', phase: 'Phase',
    dateMissing: 'Date unavailable', position: 'Position', allPositions: 'All positions',
  },
};

export const rosterNumber = (value, language, digits = 1) => value == null ? '—'
  : new Intl.NumberFormat(language === 'IT' ? 'it-IT' : 'en-GB', { maximumFractionDigits: digits }).format(value);

export const rosterDate = (value, language) => value
  ? new Intl.DateTimeFormat(language === 'IT' ? 'it-IT' : 'en-GB', { day: '2-digit', month: '2-digit', timeZone: 'UTC' }).format(new Date(`${value}T00:00:00Z`))
  : '—';